
import { Component, Vue } from "vue-property-decorator";
import { ScanforSixScanModule } from "@/store/modules/store_scanforsixscan";

@Component({
  name: "Form1",
})
export default class extends Vue {
  get input_TrueThingCode() {
    return ScanforSixScanModule.trueThingCode;
  }
  get noReadLablel() {
    return ScanforSixScanModule.noReadLablel;
  }
  get noLittleNoLabel() {
    return ScanforSixScanModule.noLittleNoLabel;
  }
  get overTimeLabel() {
    return ScanforSixScanModule.overTimeLabel;
  }
  get manyCodeLabel() {
    return ScanforSixScanModule.manyCodeLabel;
  }
  get LittleNoLabel() {
    return ScanforSixScanModule.LittleNoLabel;
  }
  get sixScanNewInterfae() {
    return ScanforSixScanModule.newSixScanInterface;
  }
}
